// LatencySparkline v0.1.0 — tiny in-card sparkline using Unicode block glyphs
// so we don't pull a chart library for a 10-sample widget. Color classifies
// the most-recent sample against the baseline (smallest observed value):
//   <= 1.5x baseline → ok (green)
//   <= 2.5x baseline → warn (yellow)
//   >  2.5x baseline → bad (red)
// On empty input we render an em-dash placeholder so the layout doesn't
// shift between "data" and "no data" states.

const BLOCKS = '▁▂▃▄▅▆▇█';

interface Props {
  values: number[];
}

export default function LatencySparkline({ values }: Props) {
  if (values.length === 0) {
    return <span className="text-dim font-mono text-[10px]">—</span>;
  }
  const baseline = Math.min(...values);
  // Cap denominator at 2x baseline minimum so a perfectly flat series still
  // renders deterministically (without this, max-baseline=0 → divide-by-zero).
  const max = Math.max(...values, baseline * 2);
  const last = values[values.length - 1] ?? baseline;
  const ratio = last / Math.max(1, baseline);
  const colorClass = ratio > 2.5 ? 'text-bad' : ratio > 1.5 ? 'text-warn' : 'text-ok';
  const out = values
    .slice(-10)
    .map((v) => BLOCKS[Math.min(7, Math.floor(((v - baseline) / Math.max(1, max - baseline)) * 7))])
    .join('');
  return <span className={`font-mono text-[10px] tracking-wider ${colorClass}`}>{out}</span>;
}
